export const UNALLOCATED_PROJECTS = 'Нераспределенные проекты';
export const UNDEFINED_VENUE = 'Неопределенная площадка';
export const UNDEFINED_STREAM = 'Неопределенный поток';